import { render, staticRenderFns } from "./AllowWebCallSwitch.vue?vue&type=template&id=7ace765a&scoped=true&"
import script from "./AllowWebCallSwitch.vue?vue&type=script&lang=js&"
export * from "./AllowWebCallSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AllowWebCallSwitch.vue?vue&type=style&index=0&id=7ace765a&lang=scss&scoped=true&"
import style1 from "./AllowWebCallSwitch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ace765a",
  null
  
)

export default component.exports